<!-- eslint-disable max-len -->
<template>
  <div
    v-if="isLoading"
    class="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4"
  >
    <div
      v-for="i in 4"
      :key="i"
      class="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6 animate-pulse"
    >
      <dt class="truncate text-sm font-medium text-gray-300">
        ...
      </dt>
      <dd class="mt-1 h-8 bg-gray-200 rounded w-3/4" />
    </div>
  </div>

  <!-- Actual Metrics -->
  <div v-else>
    <dl class="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4">
      <div
        class="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6"
      >
        <dt class="truncate text-sm font-medium text-gray-500">
          {{ t('plugins.manager.metrics.total-plugins') }}
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {{ metrics?.formattedTotalPlugins() || '-' }}
        </dd>
      </div>
      <div
        class="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6"
      >
        <dt class="truncate text-sm font-medium text-gray-500">
          {{ t('plugins.manager.metrics.total-medias') }}
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {{ metrics?.formattedTotalMedias() || '-' }}
        </dd>
      </div>
      <div
        class="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6"
      >
        <dt class="truncate text-sm font-medium text-gray-500">
          {{ t('plugins.manager.metrics.total-messages') }}
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {{ metrics?.formattedTotalComments() || '-' }}
        </dd>
      </div>
      <div
        class="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6"
      >
        <dt class="truncate text-sm font-medium text-gray-500">
          {{ t('plugins.manager.metrics.total-users') }}
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {{ metrics?.formattedTotalUsers() || '-' }}
        </dd>
      </div>
    </dl>
  </div>
</template>

<script setup lang="ts">
import usePluginStore from '@/store/plugin/plugin';
import { ref, onMounted } from 'vue';
import InstagramLiveMetadataMetrics from '@/models/plugin/instagramLiveMetadataMetrics';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const {
  pluginGetLiveMetadatasMetrics,
} = usePluginStore();

/*
  Data
*/
const isLoading = ref(true);
const metrics = ref({} as InstagramLiveMetadataMetrics);

/*
  Hooks
*/
onMounted(() => {
  pluginGetLiveMetadatasMetrics({}).then((res) => {
    [metrics.value] = res.data;
  }).catch((error) => {
    console.error('pluginGetLiveMetadatasMetrics', error);
  }).finally(() => {
    isLoading.value = false;
  });
});
</script>
